<button class="search" (click)="emit($event)"></button>
<addiction-input
    [placeholder]="placeholder | translate"
    [(ngModel)]="value"
    (keydown.enter)="emit($event)"
></addiction-input>
<button *ngIf="value" class="reset" (click)="reset()"></button>
